/* src/app/features/contratacao/limite/limite-historico/limite-historico-listagem/limite-historico-listagem.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=limite-historico-listagem.component.css.map */
